import React, { useEffect, useState } from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";
import axios from "axios";
import { route } from "../global/route.global";

function AboutMissionVision() {
  const [mission, setMission] = useState("");
  const [vision, setVision] = useState("");
  const [coreValues, setCoreValues] = useState("");

  useEffect(() => {
    getMission();
    getVision();
    getCoreValues();
  }, []);
  const getMission = async () => {
    const instance = axios.create({});
    await instance
      .get(route.root.mission)
      .then(async (res) => {
        setMission(res.data.data.content);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getVision = async () => {
    const instance = axios.create({});
    await instance
      .get(route.root.vision)
      .then(async (res) => {
        setVision(res.data.data.content);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getCoreValues = async () => {
    const instance = axios.create({});
    await instance
      .get(route.root.coreValues)
      .then(async (res) => {
        setCoreValues(res.data.data.content);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>
                  About <span>Us</span>
                </h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us" activeclass="active">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link
                          exact
                          to="/about/mission-vision"
                          activeclass="active"
                        >
                          Vision, Mission, and Core Values
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        id="about-mission-vision-values"
        className="inner-page-wrapper about-wrapper"
      >
        <div className="container">
          <div className="row mb-5 pb-5">
            <div className="col about-text">
              <p className="text-desc ">
                {vision !== "" ? (
                  <div dangerouslySetInnerHTML={{ __html: vision }} />
                ) : (
                  ""
                )}
              </p>
            </div>
            <div className="col">
              <p className="text-center">
                <img src="/assets/images/about/our-vision.png" />
              </p>
            </div>
          </div>

          <div className="row mb-5 pb-5">
            <div className="col">
              <p className="text-center">
                <img src="/assets/images/about/our-mission.png" />
              </p>
            </div>
            <div className="col about-text">
              <p className="text-desc ">
                {mission !== "" ? (
                  <div dangerouslySetInnerHTML={{ __html: mission }} />
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
          <div className="row mb-5 pb-5">
            <div className="col about-text text-values">
              {coreValues !== "" ? (
                <div dangerouslySetInnerHTML={{ __html: coreValues }} />
              ) : (
                ""
              )}
            </div>
            <div className="col about-text">
              <p className="text-center">
                <img src="/assets/images/about/coop-values.png" />
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(AboutMissionVision);
